import React from 'react';
import { fmtKwh } from '../../../../src/lib/funnelUtils';
import { NegRow } from '../types';

interface NegotiationDrillDownListProps {
    rows: NegRow[];
    onOpenDetail: (id: number) => void;
}

/** Lista compacta de negociações de um bucket/etapa — clicar numa linha abre o card no CRM.
 * Compartilhada entre o Painel de Status e o clique-para-drill-down do Funil. */
const NegotiationDrillDownList: React.FC<NegotiationDrillDownListProps> = ({ rows, onOpenDetail }) => {
    if (rows.length === 0) {
        return <p className="text-xs text-gray-400 px-4 py-3">Nenhuma negociação neste grupo.</p>;
    }
    return (
        <div className="max-h-64 overflow-y-auto custom-scrollbar bg-gray-50/60 dark:bg-gray-900/30 divide-y divide-gray-100 dark:divide-gray-700/50">
            {rows.map(r => (
                <button
                    key={r.id}
                    onClick={() => onOpenDetail(r.id)}
                    className="w-full flex items-center justify-between gap-3 px-4 py-2 text-left hover:bg-white dark:hover:bg-gray-800 transition-colors"
                >
                    <span className="text-xs font-medium text-gray-700 dark:text-gray-200 truncate">{r.cliente_nome || `Negociação #${r.id}`}</span>
                    <span className="text-[11px] text-gray-400 shrink-0">{fmtKwh(r.consumo_medio_kwh || 0)}</span>
                </button>
            ))}
        </div>
    );
};

export default NegotiationDrillDownList;
